<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>权限管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">员工</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsSettle">
      <section class="searchBox">
        <div>
          <label>项目:</label>
          <a-select
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="width: 200px"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </div>
        <div>
          <label>门店:</label>
          <a-select v-model="shops_id" style="width: 200px">
            <a-select-option
              v-for="(item, i) in shopsLIst"
              :key="i"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
        <div>
          <label>字符串:</label>
          <a-input v-model="query_field" placeholder="请输入姓名/手机号" />
        </div>
        <div>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </div>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.shop_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>
                <a v-show="item.config_data != ''" @click="setSettlePage(item)"
                  >结算配置</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 设置结算 -->
    <setSettle
      v-if="showIsSettle"
      :settleDetails="settleDetails"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 设置结算 end -->
  </div>
</template>
<script>
import axios from "axios";
import setSettle from "@/components/retail/setSettle.vue";
export default {
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddUser: false,
      query_field: "",
      totalPage: Number,
      thList: ["项目", "所属门店", "姓名", "手机号码", "操作"],
      project_id: "",
      proList: [],
      shopsLIst: [],
      shops_id: "",
      showIsSettle: false,
      settleDetails: {}
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  watch: {
    project_id() {
      this.getShops(this.project_id);
    }
  },
  components: {
    setSettle
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目列表
    this.getShops(""); //获取门店
  },
  methods: {
    hideInEdit() {
      this.showIsSettle = false;
      this.reload();
    },
    setSettlePage(val) {
      this.settleDetails = val;
      this.showIsSettle = true;
    },
    showInUserList() {
      this.showIsSettle = false;
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    getShops(proID) {
      this.shops_id = "";
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Retail_shop/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: proID,
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.shopsLIst = res.data.data.data;
            // console.log(this.shopsLIst);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
    },
    clearSearch() {
      this.query_field = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Guard/guardList";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.project_id
      };
      if (this.project_id == "") {
        delete params.project_id;
      }
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > div {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      > label,
      > div,
      input {
        display: inline-block;
      }
      label {
        margin-right: 10px;
      }
      input {
        width: 200px;
      }
    }
  }
  .projectList {
    margin-bottom: 0;
    li {
      line-height: 20px;
      display: inline-block;
      > label,
      p,
      span {
        font-size: 14px;
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
